<template>
  <div id="tabBar">
    <TabBarItem type="rebate" path="/rebate">
      <img src="~assets/img/tabbar/rebate.png"/>
    </TabBarItem>
    <TabBarItem type="mine" path="/mine">
      <img src="~assets/img/tabbar/mine.png"/>
    </TabBarItem>
    <TabBarItem type="rule" path="/rule">
      <img src="~assets/img/tabbar/rule.png"/>
    </TabBarItem>
    <TabBarItem type="close" @close="close" path="/close">
      <img src="~assets/img/tabbar/close.png"/>
    </TabBarItem>
  </div>
</template>

<script>
  import TabBarItem from "./TabBarItem.vue"
  export default {
    data () {
      return {

      }
    },
    components: {
      TabBarItem
    },
    methods:{
      close(){
        this.sendToClient('close?')
      }
    }
 }
</script>

<style>
/* div {
  background-color: bisque;
}
router-view{
  background-color: red;
} */

  #tabBar{
    background-color: black;
    /* display:flex; */
    flex-direction: column;
    /* width: 20%; */
    width: 20vw;
	  height: 100vh;	
    z-index: 133;
  }
 
 
</style>


// WEBPACK FOOTER //
// src/views/tabbar/TabBar.vue